import * as yup from 'yup'

export const schemaUpdateSubcontractModal = yup.object().shape({
    subcontract: yup.object().shape({
        subcontract_code: yup.string().required(),
        subcontract_name: yup.string().required('subcontract-name-validate'),
        subcontract_effective_date: yup.string().required(),
        subcontract_status: yup
            .string()
            .required('subcontract-status-validate'),
    }),
})
